import { Route, Routes } from 'react-router-dom'

import Details from './screens/Details'

const OrderBundleRoutes = () => (
  <Routes>
    <Route index element={<Details />} />
  </Routes>
)

export default OrderBundleRoutes
